import { getConfig } from 'utils/config';
import { enrollerBranding } from './enroller';
import { greenheartBranding } from './greenheart';

const { appBrandTheme } = getConfig();
export const branding = appBrandTheme === 'greenheart' ? greenheartBranding : enrollerBranding;
